export default {
    battle_born_media: {
        value: 1,
        label: 'Battle Born Media',
        key: 'battle born media'
    }
};
